<template>
    <v-col cols="12" md="12">
        <v-row class="justify-center align-center">
            <custom-date-picker
                v-model="fromDateValue"
                format="YYYY-MM-DD"
                type="date"
                placeholder="From"
                class="ma-2"
                :onDateChange="handleFromDateChange"
            ></custom-date-picker>
            <custom-date-picker
                format="YYYY-MM-DD"
                v-model="toDateValue"
                type="date"
                placeholder="To"
                class="ma-2"
                :onDateChange="handleToDateChange"
            ></custom-date-picker>

            <v-btn class="ma-2" tile color="primary" dark @click="saveRunsheet" :disabled="ploading">
                <span>Save &nbsp;</span>
                <div v-if="ploading" style="margin-left: 5px" class="loading-animation"></div>
            </v-btn>
            <v-btn class="ma-2" tile color="primary" dark @click="download_run_sheet" :disabled="ploading">
                <span>Download &nbsp;</span>
                <!--<div v-if="ploading" style="margin-left: 5px;" class="loading-animation"></div>-->
            </v-btn>
        </v-row>
        <div class="tabs-container mt-5">
            <v-tabs v-model="activeTab">
                <v-tab href="#RECORDER"> {{RUNSHEET_TABS.RUNSHEET.LABEL}} </v-tab>
                <v-tab href="#TAX"> {{RUNSHEET_TABS.TAX.LABEL}} </v-tab>
                <v-tab href="#ASSESSOR"> {{RUNSHEET_TABS.ASSESSOR.LABEL}} </v-tab>
                <v-tab href="#COURT"> {{RUNSHEET_TABS.COURT.LABEL}} </v-tab>
            </v-tabs>
            <div v-if="overallScrappingState" class="scrapping-details-container">
                <span class="scrapping-status">
                    {{ loadingScrappingStatus?'Loading status...':'' }}
                    <template v-if="!loadingScrappingStatus">
                        <div
                            v-if="![SCRAPPER_STATES.NA,SCRAPPER_STATES.NOT_AVAILABLE].includes(scrapperState)"
                            class="status-dot"
                            :class="{[scrapperState]:Boolean(scrapperState)}"
                        />
                        {{SCRAPER_STATUSES[scrapperState] }}
                    </template>
                </span>
                <v-tooltip top :disabled="!getDisabledTooltipText()">
                    <template v-slot:activator="{ on, attrs }">
                        <div v-on="on" class="d-inline-block">
                            <v-btn
                                v-if="shouldShowTriggerButton"
                                color="primary"
                                v-bind="attrs"
                                :disabled="overallScrappingState===SCRAPPER_STATES.RUNNING||loadingScrappingData||loadingScrappingStatus"
                                @click="triggerScrapping"
                            >
                                {{ getScrapperButtonText() }}
                            </v-btn>
                        </div>
                    </template>
                    <span>{{ getDisabledTooltipText() }}</span>
                </v-tooltip>
            </div>
        </div>
        <v-tabs-items v-model="activeTab" class="run-sheet-tabs-container">
            <v-tab-item :value="RUNSHEET_TABS.RUNSHEET.VALUE">
                <v-col cols="12" md="12" class="d-flex align-center datatableContainer" id="datatableContainer">
                    <!--<dataTable :exportURL="exportURL" ref="dataTable" v-show="isHidden" @pageChanged="paginateOrder" :dataTableData="dataTableData" :headers="headers" :loading="loading" />-->
                    <v-form ref="runsheetForm" v-model="formSheetValid" @submit.prevent="saveRunsheet">
                        <dataTable
                            :order="order"
                            :dt_data="dt_data"
                            ref="dataTable"
                            v-show="isHidden"
                            @pageChanged="paginateOrder"
                            :dataTableData="dataTableData"
                            :headers="headers"
                            :checkboxEnable="true"
                            :loading="loading"
                            :expandTable="true"
                            :hidePage="true"
                            :document_reasons="document_reasons"
                            :refetchData="searchOrders"
                            :fetchOnActive="activeTab === RUNSHEET_TABS.RUNSHEET.VALUE"
                        />
                    </v-form>
                </v-col>
            </v-tab-item>
            <v-tab-item :value="RUNSHEET_TABS.TAX.VALUE">
                <RunSheetTaxTab :order="order" :fetchOnActive="activeTab === RUNSHEET_TABS.TAX.VALUE" />
            </v-tab-item>
            <v-tab-item :value="RUNSHEET_TABS.ASSESSOR.VALUE">
                <RunSheetAccessorTab
                    :order="order"
                    :fetchOnActive="activeTab === RUNSHEET_TABS.ASSESSOR.VALUE"
                    :scrapperState="overallScrappingState"
                    :refetchScrapperState="getScrappingStatus"
                    :tooltipText="getDisabledTooltipText()"
                />
            </v-tab-item>
            <v-tab-item :value="RUNSHEET_TABS.COURT.VALUE">
                <RunSheetCourtTab :order="order" :fetchOnActive="activeTab === RUNSHEET_TABS.COURT.VALUE" />
            </v-tab-item>
        </v-tabs-items>
    </v-col>
</template>

<script>
// @ advance search component
import dataTable from '@/components/RunSheetdataTable.vue'
import RunSheetTaxTab from '@/components/runSheetTaxTab.vue'
import RunSheetAccessorTab from '@/components/runSheetAssessorTab.vue'
import RunSheetCourtTab from '@/components/runSheetCourtTab.vue'
import customDatePicker from '@/components/commonComponents/customDatePicker.vue'
import API_URL from '@/common/config'
import { GETORDERRUNSHEET, GETTAXHUBDATA, SAVEORDERRUNSHEET, CREATEFINALPACKAGE,
  GETDOCUMENTREASONS, GETRUNSHEETSCRAPPINGSTATUS, TRIGGERRUNSHEETSCRAPPING } from '@/store/actions.type'
import { transformReasonsData } from '@/components/pdf/utils/helpers'
import { SCRAPER_STATUSES, SCRAPPER_STATES, RUNSHEET_TABS } from '@/constants'

export default {
  name: 'AdvanceSearch',
  components: {
    dataTable,
    customDatePicker,
    RunSheetTaxTab,
    RunSheetAccessorTab,
    RunSheetCourtTab
  },
  data () {
    return {
      dataTableData: {
        count: 0,
        next: null,
        previous: null,
        results: []
      },
      dt_data: {},
      exportURL: null,
      baseAPIUrl: API_URL,
      loading: false,
      ploading: false,
      countyURL: null,
      itemsPerPage: 10,
      page: 1,
      isHidden: false,
      customerData: null,
      fromDate: false,
      frmDate: null,
      orderToDate: false,
      ordToDate: null,
      clients: [],
      products: [],
      vendors: [],
      orderStatusList: [],
      fromDateValue: null,
      toDateValue: null,
      search: {
        rts: null,
        client_ref: null,
        client: null,
        product: null,
        state: null,
        county: null,
        address: null,
        borrower: null,
        order_stage: null,
        vendor: null
      },
      document_reasons: null,
      headers: [
        { text: 'DOC Status', value: 'piq', sortable: true },
        { text: 'DOC ID', value: 'doc_id', sortable: true },
        { text: 'REC DATE', value: 'rec_date', sortable: true },
        { text: 'INST', value: 'doc_type', sortable: true },
        { text: 'BOOK PAGE', value: 'instrument_number', sortable: true },
        { text: 'SEARCH TYPE', value: 'index_type', sortable: false },
        { text: 'SEARCH PARAMETER', value: 'search_type', sortable: false },
        { text: '', value: 'action', sortable: false }
      ],
      formSheetValid: false,
      activeTab: 'RECORDER',
      scrapperState: null,
      loadingScrappingData: false,
      loadingScrappingStatus: false,
      SCRAPER_STATUSES: SCRAPER_STATUSES,
      SCRAPPER_STATES: SCRAPPER_STATES,
      shouldShowTriggerButton: false,
      RUNSHEET_TABS: RUNSHEET_TABS,
      allScraperStates: null,
      overallScrappingState: null
    }
  },
  props: {
    order: null
  },
  computed: {
    frmDateVal () {
      return this.frmDate
    },
    orderToDateVal () {
      return this.ordToDate
    }
  },
  mounted () {
    this.getDocumentReasons()
    this.getScrappingStatus()
  },
  methods: {
    saveRunsheet () {
      if (!this.$refs.runsheetForm.validate()) {
        alert('Complete the form first')
      } else {
        this.ploading = true
        let orderPayload = {
          order__id: this.order.id
        }
        this.$store.dispatch(SAVEORDERRUNSHEET, orderPayload)
          .then(response => {
            this.createFinalPackage()
          })
      }
    },
    download_run_sheet () {
      let downloadUrl = `${this.baseAPIUrl.BASE_API_URL}/download-run-sheet-pdf/${this.order.id}`
      window.open(downloadUrl)
    },
    createFinalPackage () {
      this.aloading = true
      let finalPackagePayload = {
        order: this.order.id,
        name: `RTS-Order-Summary-${this.order.id}-${new Date().getTime()}.pdf`
      }
      this.$store
        .dispatch(CREATEFINALPACKAGE, finalPackagePayload)
        .then(response => {
          alert('Package created!!!')
          this.ploading = false
        })
    },
    paginateOrder (conf) {
      this.itemsPerPage = conf.itemsPerPage
      this.page = conf.page
      const { sortBy = [], sortDesc = [] } = conf
      if (sortBy && sortBy.length) {
        let sortKey = sortBy[0]
        let sortType = ''
        if (sortDesc && sortDesc.length) {
          sortType = sortDesc[0] ? '-' : ''
        }
        if (sortKey === 'doc_id') {
          sortKey = 'doc_id_as_int'
        }
        const ordering = sortType + sortKey
        this.searchOrders(ordering)
      } else {
        this.searchOrders()
      }
    },
    getAutoCompleteData (data) {
      if (data.__field === 'state') {
        this.search.stateName = data.id
        this.countyURL = `counties/?state__id=${data.id}`
      } else if (data.__field === 'county') {
        this.search.county = data.id
      }
    },
    cancelSearch: function () {
      this.$router.push('/')
    },
    resetSearch: function () {
      this.dataTableData.results = []
      this.page = 1
      this.search = {
        rts: null,
        client_ref: null,
        client: null,
        product: null,
        stateName: null,
        county: null,
        address: null,
        borrower: null,
        order_stage: null,
        vendor: null
      }
      this.orderSendDate = null
      this.oderAssignDateVal = null
      this.frmDate = null
      this.ordToDate = null
      this.$refs.dataTable.options.page = 1
      this.$refs.autocomplete.model = ''
      this.$refs.autocompletecounty.model = null
      this.searchOrders()
    },
    findSearch: function () {
      this.page = 1
      this.$refs.dataTable.options.page = 1
      this.ploading = true
      this.searchOrders()
    },
    searchOrders: function (ordering = null) {
      this.loading = true
      this.isHidden = true
      let orderPayload = {
        order__id: this.order.id,
        page: 1,
        page_size: 10000
      }
      const { page, itemsPerPage, sortBy = [], sortDesc = [] } = this.$refs.dataTable.options

      let orderRunSheetPayload = {
        ...orderPayload,
        page: page,
        page_size: itemsPerPage
      }

      if (sortBy && sortBy.length) {
        let sortKey = sortBy[0]
        let sortType = ''
        if (sortDesc && sortDesc.length) {
          sortType = sortDesc[0] ? '-' : ''
        }
        if (sortKey === 'doc_id') {
          sortKey = 'doc_id_as_int'
        }
        orderRunSheetPayload.ordering = sortType + sortKey
      }

      const runSheetPayloadString = Object.keys(orderRunSheetPayload).map(key => key + '=' + orderRunSheetPayload[key]).join('&')

      var queryString = Object.keys(orderPayload).map(key => key + '=' + orderPayload[key]).join('&')
      this.$store.dispatch(GETORDERRUNSHEET, runSheetPayloadString)
        .then(response => {
          this.orderList = response.results
          if (this.order.prior_effective_date) {
            const fromDate = new Date(this.order.prior_effective_date)
            this.fromDateValue = fromDate
            this.toDateValue = new Date()
          }
          this.dataTableData = response
          this.exportURL = `${this.baseAPIUrl.BASE_API_URL}/download_orders/?${queryString}`
          this.loading = false
          this.ploading = false
        })
      this.$store.dispatch(GETTAXHUBDATA, queryString)
        .then(response => {
          let resp = response.results[0]
          if (resp && resp.data.dt_data.StatusDescription === 'Report generation completed.') {
            this.dt_data = resp.data.dt_data.Reports[0]
          }
        })
    },
    handleFromDateChange (date) {
      this.fromDateValue = date
    },
    handleToDateChange (date) {
      this.toDateValue = date
    },
    getDocumentReasons () {
      this.$store.dispatch(GETDOCUMENTREASONS)
        .then(response => {
          this.document_reasons = transformReasonsData(response)
        })
    },
    handleDataOutsideDateRange () {
      this.dataTableData.results.forEach(data => {
        const updatedRecDate = new Date(data.rec_date)
        const fromDate = new Date(this.fromDateValue)
        const toDate = new Date(this.toDateValue)
        if ((updatedRecDate < fromDate || updatedRecDate > toDate) && !data.piq) {
          data.piq = 'OBT'
          this.$refs.dataTable.change_piq(data)
        }
      })
    },
    getScrappingStatus () {
      this.loadingScrappingStatus = true
      this.$store.dispatch(GETRUNSHEETSCRAPPINGSTATUS, {
        orderId: this.order.id
      }).then(response => {
        this.shouldShowTriggerButton = response.available_dag
        const allScraperStates = response.site_wise_status
        this.overallScrappingState = response.state
        if (allScraperStates && allScraperStates[this.activeTab]) {
          this.scrapperState = allScraperStates[this.activeTab].state
        } else {
          if (!response.available_dag) {
            this.scrapperState = SCRAPPER_STATES.NOT_AVAILABLE
          }
        }
        this.allScraperStates = allScraperStates
      }).finally(() => {
        this.loadingScrappingStatus = false
      })
    },
    getScrapperButtonText () {
      let text = 'Retrieve again'
      if (this.loadingScrappingData) {
        if (this.scrapperState === SCRAPPER_STATES.NA) {
          text = 'Retrieving...'
        }
        text = 'Retrieving...'
      } else if (this.scrapperState === SCRAPPER_STATES.NA) {
        text = 'Retrieve'
      } else {
        text = 'Retrieve again'
      }
      return text
    },
    triggerScrapping () {
      this.loadingScrappingData = true
      this.$store.dispatch(TRIGGERRUNSHEETSCRAPPING, {
        orderId: this.order.id
      }).then(() => {
        this.getScrappingStatus()
      }).finally(() => {
        this.loadingScrappingData = false
      })
    },
    getDisabledTooltipText () {
      let text = ''

      const runningScraper = Object.entries(this.allScraperStates).filter(
        ([name, details]) => details.state === SCRAPPER_STATES.RUNNING
      )
      if (runningScraper && runningScraper.length) {
        return `Scraper running for ${runningScraper.map(([name]) => name).join(', ')}. Please wait for it to complete.`
      }

      if (this.loadingScrappingData || this.loadingScrappingStatus) {
        return 'Loading scraper status...'
      }
      return text
    }
  },
  watch: {
    fromDateValue () {
      if (this.toDateValue) {
        this.handleDataOutsideDateRange()
      }
    },
    toDateValue () {
      if (this.fromDateValue) {
        this.handleDataOutsideDateRange()
      }
    },
    activeTab () {
      this.getScrappingStatus()
    }
  }
}
</script>
<style>
.advance-col{
    padding-bottom:0px;
}
.v-input__slot, .v-text-field__details{
    margin-bottom:0px;
}
.v-data-table>.v-data-table__wrapper tbody tr.v-data-table__expanded__content {
    box-shadow: none;
}
.refDocDivider {
  border: solid 2px black;
  background: #6e92a2;
}
.refDoc {
  border: solid 2px black;
  background: #6ea296;
}

.v-data-table td {
    font-size: 12px !important;
    font-weight: normal !important;
}

.datatableContainer .v-data-table th{
  white-space: nowrap;
}

.v-application .text-start {
    text-align: start !important;
    border-bottom: none !important;
}

.loading-animation {
  border: 2px solid #f3f3f3; /* Light gray */
  border-top: 2px solid #fff; /* White spinner */
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin 1s linear infinite;
  margin: auto;
}

.run-sheet-tabs-container {
  background-color: transparent !important;
}

.datatableContainer {
  padding: 12px 0px;
}

.v-tabs__content,
.v-tabs-items {
  overflow: visible !important;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.tabs-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
}

.tabs-container .v-tabs {
  display: flex;
}

.scrapping-details-container {
  padding: 0px 12px;
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 12px;
  text-wrap: nowrap;
}

.scrapping-details-container .primary {
  border-radius: 4px !important;
  font-size: 12px;
  padding: 4px;
  min-width: unset !important;
}

.scrapping-status {
  border-radius: 20px;
  padding: 6px 10px;
  font-size: 14px;
  background-color: rgb(var(--secondary-color));
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgb(var(--primary-color));
}

.status-dot.failed {
  background-color: rgb(var(--error-color));
}

.status-dot.success {
  background-color: rgb(var(--success-color));
}

.datatableContainer th .v-icon{
  margin-left:6px;
  margin-bottom:4px;
}
</style>
